export default class ItemCategoryActions {

    static NEW_DATA = 'NEW_DATA';
    static UPDATE_DATA='UPDATE_DATA';
    static SHOW_DATA='SHOW_DATA';
    static VIEW_DATA='VIEW_DATA';
    static DELETE_DATA='DELETE_DATA';
    static ON_SUBMIT='ON_SUBMIT';
    static ERROR_DATA='ERROR_DATA';
    static PROCESS_DATA='PROCESS_DATA';
    static RESET_DATA='RESET_DATA';
    static GET_HELPER_ITEMCATEGORY='GET_HELPER_ITEMCATEGORY';
    static SUCCESS_DATA='SUCCESS_DATA';
    static ERROR_SERVER='ERROR_SERVER'
    static RESET_LIST='RESET_LIST'
    
    static submit(){
      return {
        type: ItemCategoryActions.ON_SUBMIT
      };
    }
  
    static create(data) {
      return {
        type: ItemCategoryActions.NEW_DATA,
        payload: data
      };
    }
  
    static update(data) {
      return {
        type: ItemCategoryActions.UPDATE_DATA,
        payload: data
      };
    }
  
    static view(data) {
      return {
        type: ItemCategoryActions.VIEW_DATA,
        payload: data
      };
    }
  
    static delete(data) {
      return {
        type: ItemCategoryActions.DELETE_DATA
      };
    }
  
    static list(data) {
      return {
        type: ItemCategoryActions.SHOW_DATA,
        payload: data
      };
    }
    static error(error){
      return {
        type: ItemCategoryActions.ERROR_DATA,
        payload: error
      };
    }
    static success(){
      return {
        type: ItemCategoryActions.SUCCESS_DATA,
      };
    }
    static process(){
      return {
        type: ItemCategoryActions.PROCESS_DATA,
      };
    }
    static resetList(){
      return {
        type: ItemCategoryActions.RESET_LIST,
      };
    }
    static reset(){
      return {
        type: ItemCategoryActions.RESET_DATA,
      };
    }
    static helper(data){
      return {
        type: ItemCategoryActions.GET_HELPER_ITEMCATEGORY,
        payload:data
      };
    }
    static errorInternal(data){
      return {
        type: ItemCategoryActions.ERROR_SERVER,
        payload:data
      };
    }
  }